
$(document).ready(function(){
	init(); 

	//Manually triggering the corona popup!
	var checkCustomPopupCookie = getCookie('rhubarb_qe_custom_popup');
	if ( checkCustomPopupCookie == null ) {
		var targetPopup = 'queen-elizabeth';

		if ( $('#'+targetPopup).length ) {
			//Set custom cookie popup so it dont show again
			setCookie('rhubarb_qe_custom_popup', 'popped', 0.5);

			setTimeout(function(){
				$('.popup-wrapper').addClass('active');
				$('#'+targetPopup).addClass('active');
				$('body').addClass('popup-active');
			}, 500);
		}
	}

	$(window).trigger('scroll');
	$(window).trigger('resize');  
});

function init(){

	var mediumBP = 990;


	new WOW().init();

	//Modernizir
	modernizir();

	//lazyload
	lazyload();
	
	//Header JS
	header();

	//MatchHeight
	heightMatch();

	//Smooth Scroll
	smoothScroll();


	//Module Scripts
		//Page Hero Module
		modulePageHero();

		//Content Image Block Module
		moduleContentImageBlock();

		//Map Block
		moduleMapBlock();

		//Menus Module
		moduleMenus();

		//Slider Module
		moduleSlider();

		//Testimonials Module
		moduleTestimonials();

		//Events module
		moduleEvents();

		//Filter Module
		moduleFilter();

		//Newsroom Module
		moduleNewsroom();

		//Content Columns
		contentColumns();

		//Team carousel
		teamCarousel();
		
	//Module Scripts END


	//Page Scripts

		//Front Page
		pageFront();
		deliveryPageScripts();

	//Page Scripts END



	//Revealing header logic
	window.scrollCache = 0;
	$(window).scroll(function() {
		headerScroll();
	});

	//Popup Logic
	initPopups();
}





 function setCookie(name,value,days) {
  var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  function eraseCookie(name) {
      document.cookie = name+'=; Max-Age=-99999999;';
  }